import * as yup from "yup";

const estacionesValidacionEsquema = yup.object().shape({
    nombre: yup.string().required(),
});

export default estacionesValidacionEsquema;
